import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-import-system-users-data',
  templateUrl: './import-system-users-data.component.html',
  styleUrls: ['./import-system-users-data.component.scss']
})
export class ImportSystemUsersDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
